var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 9.43147V5.59127C19.684 5.59127 18.2743 5.11125 17.3646 4.17824C16.4309 3.11343 15.9078 1.76497 15.8854 0.365089V0.0878919L12.1563 0C12.1563 0 12.1563 0.155501 12.1563 0.365089V15.5974C12.0283 16.2779 11.689 16.9039 11.1841 17.3907C10.6792 17.8775 10.0331 18.2018 9.33287 18.3198C8.63267 18.4378 7.91215 18.3438 7.26858 18.0504C6.625 17.7571 6.08936 17.2786 5.73397 16.6795C5.37858 16.0804 5.22055 15.3896 5.28121 14.7003C5.34187 14.011 5.61831 13.3564 6.07319 12.8249C6.52809 12.2934 7.13953 11.9106 7.82497 11.7281C8.51042 11.5456 9.23687 11.5723 9.90625 11.8045V8.08605C9.51597 8.02379 9.12118 7.99214 8.7257 7.99139C7.30277 7.99139 5.9118 8.40219 4.72868 9.17183C3.54556 9.94147 2.62343 11.0354 2.0789 12.3153C1.53437 13.5951 1.39189 15.0035 1.66949 16.3622C1.94709 17.7209 2.6323 18.9689 3.63846 19.9485C4.64462 20.9281 5.92654 21.5951 7.32213 21.8654C8.71771 22.1357 10.1643 21.997 11.4789 21.4668C12.7935 20.9367 13.9171 20.0389 14.7077 18.8871C15.4982 17.7352 15.9201 16.381 15.9201 14.9957C15.9194 14.7087 15.9008 14.4219 15.8646 14.1371V7.95083C17.5603 8.98183 19.5332 9.49732 21.5312 9.43147Z",
    fill: "#273043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktokIcon.c9ce67733564f798055edc8a8e024ea7.svg";
export { ForwardRef as ReactComponent };